"use client";

import cn from "clsx";
import styles from "./Faculty.module.scss";
import { useEffect, useState } from "react";
import { imgPathReplace } from "@/helpers/imgPathReplace";
import Carousel from "@/components/molecules/CustomCarousels/Carousel";

export default function FacultyCarousel({
  facultyDetails,
  isCareerPage, isConfigured
}: {
  facultyDetails: any;
  isCareerPage?: boolean;
  isConfigured?: boolean
}) {
  const [screenWidth, setScreenWidth] = useState<number>(0);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    handleResize(); // Set initial width
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [activeIndex, setActiveIndex] = useState(0);
  const [delayedActiveIndex, setDelayedActiveIndex] = useState(0);

  useEffect(() => {
    const delayTimeout = setTimeout(() => {
      setDelayedActiveIndex(activeIndex);
    }, 500);
    return () => clearTimeout(delayTimeout);
  }, [activeIndex]);

  return (
    <div className={cn(styles.root)}>
      <Carousel
        children={facultyDetails.map(({ id, attributes }, i) => (
          <FacultySlide isConfigured={isConfigured} isCareerPage={isCareerPage} key={id} faculty={attributes} isMobile={screenWidth <= 480} index={i} isActive={screenWidth <= 480 ? i === delayedActiveIndex : false} />
        ))}
        config={{
          spaceBetween: 20,
          autoplay: {
            delay: 2000
          },
          speed: 500,
          onSlideChange: (params) => setActiveIndex(params?.index),
          pagination: {
            className: "text-center my-5",
          },
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            481: {
              slidesPerView: 1.2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 25,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 60,
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 50
            },
            1900: {
              slidesPerView: 3,
              spaceBetween: 120
            }
          }
        }}
      />
    </div>
  );
}

interface Faculty {
  image: string;
  Name: string;
  Department: string;
  Designation: string;
  ShortDesc: string;
  Picture?: {
    source?: {
      data?: {
        attributes?: {
          url?: string;
        };
      }[];
    };
  };
}

interface MentorItemProps {
  faculty: Faculty;
  isActive: boolean;
  isMobile: boolean;
  index: number;
  isCareerPage?: boolean;
  isConfigured?: boolean
}

const FacultySlide: React.FC<MentorItemProps> = ({ faculty, isActive, isMobile = true, index, isCareerPage, isConfigured }) => {
  const landingImageUrl = faculty?.Picture?.source?.data?.[0]?.attributes?.url || "";
  const imagetoShow = isConfigured ? landingImageUrl : faculty?.image
  return (
    <div className={cn(styles.mentorItem, {
      [styles.active]: isActive,
      [styles.odd]: index % 2 === 0,
      [styles.even]: index % 2 !== 0,
    })}>
      <div className={`${isCareerPage ? "lg:w-full" : ""} ${styles.mentorImg}`}>
        <img
          src={imgPathReplace(imagetoShow)}
          srcSet={imgPathReplace(imagetoShow)}
          alt={`${faculty?.Name} Image` || "Amity Online"}
          title={`${faculty?.Name} Image` || "Amity Online"}
          width={isMobile ? 289 : 257}
          height={isMobile ? 300 : 250}
          loading="lazy"
        />
      </div>
      <div className={styles.mentorDetailBlock}>
        <div className={styles.mentorDetail}>
          <h3>{faculty?.Name}</h3>
          <p>
            {faculty?.Department} <br />
            {faculty?.Designation}
          </p>
        </div>
        <div className={styles?.mentorDesc}>
          <p>{faculty?.ShortDesc}</p>
        </div>
      </div>
    </div>
  );
};

